<style scoped>
.bidding{
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 10px;
}
.bidding-menu{
    display: inline-block;
}
.bidding-content{
    max-width: 1080px;
    margin: 0 auto;
    padding: 0;
    display: inline-block;
}
</style>

<template>
    <div class="bidding">
        <div class="m-b-10">
            <a class="m-r-20" :class="query.citycode==='320500'?'active':''" @click="handleChangeCity('320500')">苏州</a>
            <a class="m-r-20" :class="query.citycode==='360100'?'active':''" @click="handleChangeCity('360100')">南昌</a>
            <a class="m-r-20" :class="query.citycode==='440600'?'active':''" @click="handleChangeCity('440600')">佛山</a>
            <a class="m-r-20" :class="query.citycode==='510100'?'active':''" @click="handleChangeCity('510100')">成都</a>
            <a class="m-r-20" :class="query.citycode==='320200'?'active':''" @click="handleChangeCity('320200')">无锡</a>
            <a class="m-r-20" :class="query.citycode==='330100'?'active':''" @click="handleChangeCity('330100')">杭州</a>
        </div>

        <Collapse simple accordion>
            <Panel v-for="item in bindingData" :key="item.id">
                {{item.title}}
                <span class="remark m-l-20">{{item.datetime}}</span>
                <div slot="content" v-html="item.html"></div>
            </Panel>
        </Collapse>

        <Page :total="total" :page-size="query.pageSize" :current="query.pageNumber" show-total  class="m-t-10" @on-change="handlePageChange"/>

    </div>
</template>

<script>
import { getBiddingInfo } from '@/api/website'

export default {
  data () {
    return {
      query: {
        pageSize: 15,
        pageNumber: 1,
        citycode: ''
      },
      bindingData: [],
      total: 0
    }
  },
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.loadBiddingData()
    },
    loadBiddingData () {
      getBiddingInfo(this.query).then(res => {
        this.bindingData = res.list
        this.total = res.totalRow
      })
    },
    handlePageChange (page) {
      this.query.pageNumber = page
      this.loadBiddingData()
    },
    handleChangeCity (citycode) {
      this.query.citycode = (this.query.citycode === citycode) ? '' : citycode
      this.query.pageNumber = 1
      this.loadBiddingData()
    }
  }
}
</script>
